const STOREFRONT_API_TOKEN = "91de2531385f16d3501baa7225236f61";

window.alertClassName = function alertClassName(elem) {
  // alert(`Class name: ${elem.className}`);
}

export class ProductLinking {
  constructor(options) {
    // console.log("Product linking options:", options);

    if (!options) {
      throw new Error("Options required for ProductLinking module.");
    }

    const { product, section_id } = options;

    this.section_id = section_id;

    if (!product) {
      throw new Error("product required in ProductLinking product");
    }

    this.product = product;

    this.search();
  }

  async fetchAllStorefrontByQuery(search) {
    let hasNextPage = false;
    let cursor = null;
    const items = [];

    do {
      const query = await this.searchStorefrontApi(search, cursor);
      if (!query.data) throw new Error("Failed to link products");

      const { products } = query.data;
      const { edges, pageInfo } = products;

      // console.log("Multi Fetch:", pageInfo, edges.length, cursor);

      items.push(...edges);
      hasNextPage = pageInfo.hasNextPage;
      cursor = pageInfo.endCursor;
    } while (hasNextPage);

    return items;
  }

  async search() {
    const title = this.product.title;
    const sizeIndex = this.product.options.findIndex(
      (option) => option.toLowerCase() === "size"
    );
    const productskus = this.product.variants.map((variant) =>
      variant.sku.slice(0, 10)
    );
    const query = await this.searchStorefrontApi(this.normalizeTitle(title));
    const results = await this.searchStorefront(this.normalizeTitle(title));
    const matches = results.results.filter(
      (result) =>
        this.normalizeTitle(result.title) === this.normalizeTitle(title) &&
        result.id !== this.product.id
    );

    const [currentVariant] = this.product.variants;

    const edges = await this.fetchAllStorefrontByQuery(
      this.normalizeTitle(title)
    );

    const edgeSkus = edges.flatMap(({ node }) =>
      node.variants.nodes.map((variant) => variant.sku)
    );
    const itemsWithMatchingSku = edges.filter(({ node }) =>
      node.variants.nodes.some((variant) => {
        const size = variant.selectedOptions.find(
          (option) => option.name.toLowerCase() === "size"
        );
        const sku = variant.sku.slice(0, 10);
        // console.log("Comparing SKUs:", size?.value, productskus, sku);

        return productskus.includes(sku);
      })
    );

    // console.log(
    //   "Item with Matching:",
    //   this.product,
    //   edges,
    //   itemsWithMatchingSku,
    //   productskus,
    //   edgeSkus
    // );

    const items = itemsWithMatchingSku.map(({ node }) => {
      const optionValuesMap = node.options.map((opt) => ({
        name: opt.name,
        values: opt.optionValues.map((v) => v.name),
      }));

      return {
        handle: node.handle,
        available: node.availableForSale,
        title: node.title,
        option_values: optionValuesMap.flatMap((opt) => opt.values),
        options: optionValuesMap,
        size:
          optionValuesMap.find((opt) => opt.name.toLowerCase() === "size")
            ?.values || [],
      };
    });

    const optionNames = [
      ...new Set(items.flatMap((item) => item.options.map((opt) => opt.name))),
    ];

    const itemsByOptions = optionNames.map((optionName) => {
      const values = new Set();

      items.forEach((item) => {
        const itemValues =
          item.options.find((opt) => opt.name === optionName)?.values || [];
        itemValues.forEach((val) => values.add(val));
      });

      return { name: optionName, values: [...values] };
    });

    const readyOptions = itemsByOptions.map(({ name, values }) => {
      const currentOptionIndex = this.product.options.findIndex(
        (opt) => opt.toLowerCase() === name.toLowerCase()
      );
      const currentValue = currentVariant.options[currentOptionIndex];

      return {
        name,
        values: values.map((value) => {
          const item = items.find((item) => {
            const targetOptions = [...currentVariant.options];
            targetOptions[currentOptionIndex] = value;
            return item.option_values.every((optVal) =>
              targetOptions.includes(optVal)
            );
          });

          return { value, item: item };
        }),
      };
    });

    // console.log("ReadyOptions:", readyOptions);

    for (let i = 0; i < readyOptions.length; i++) {
      const { name, values } = readyOptions[i];

      if (name == 'Size' || name == 'size') {

        const $fieldset = this.getOptionFieldset(i);
  
        // ✅ HTML rendering with fixed onclick
        const valuesHtml = values.map(({ value, item }) => {
          if (currentVariant.options.includes(value)) return "";
          if (!item) return "";
  
          return `
            <a class="size-option" 
               ${item?.available === false ? "disabled" : ""} 
               href="/products/${item?.handle}" 
               onclick="alertClassName(this)">
               ${value}
            </a>
          `;
        });
  
        $fieldset.innerHTML += valuesHtml.join("");
  
        const $allOptions = $fieldset.querySelectorAll("a.size-option,input");
  
        const sorted = [...$allOptions].sort((a, b) => {
          const valA = (a.tagName === "INPUT" ? a.value : a.textContent).trim();
          const valB = (b.tagName === "INPUT" ? b.value : b.textContent).trim();
          const numA = parseInt(valA, 10);
          const numB = parseInt(valB, 10);
  
          if (!isNaN(numA) && !isNaN(numB)) {
            return numA - numB;
          } else {
            return valA.localeCompare(valB);
          }
        });
  
        // console.log("Sorting options:", sorted, $fieldset);
  
        sorted.forEach(($el) =>
          $fieldset
            ? $fieldset.append(
                $el.tagName === "INPUT" ? $el.parentElement : $el
              )
            : null
        );
      }
    }
  }

  searchStorefront(query) {
    // console.log("Search", query);
    return fetch(`/search?q=${query}&type=product&view=json`).then((res) =>
      res.json()
    );
  }

  searchStorefrontApi(query, after) {
    // console.log("Storefront query:", `${query}*`);

    return this.storefrontFetch(`{
        products(first: 250, query: "title:${query.replace('"', "")}*" ${
      after ? `, after:"${after}"` : ""
    }) {
          edges {
            node {
              id
              handle
              availableForSale
              title
              onlineStoreUrl
              options(first: 10) {
                name
                optionValues { name }
              }
              variants(first: 30) {
                nodes {
                  sku
                  selectedOptions {
                    value
                    name
                  }
                }
              }
            }
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }`);
  }

  normalizeTitle(text) {
    return text.replace(/\s*\([^)]*\)\s*/g, " ").trim();
  }

  storefrontFetch(body) {
    return fetch("/api/2025-01/graphql.json", {
      method: "POST",
      body,
      headers: {
        "Content-Type": "application/graphql",
        "X-Shopify-Storefront-Access-Token": STOREFRONT_API_TOKEN,
      },
    }).then((res) => res.json());
  }

  getOptionFieldset(index) {
    return this.fieldsets[index];
  }

  get fieldsets() {
    return [
      ...document.querySelectorAll(
        `variant-selects#variant-selects-${this.section_id} fieldset`
      ),
    ];
  }

  get fieldSet() {
    if (this.sizePosition === -1) return null;

    const $fieldsets = [
      ...document.querySelectorAll(
        `variant-selects#variant-selects-${this.section_id} fieldset`
      ),
    ];

    return $fieldsets[this.sizePosition];
  }

  get sizePosition() {
    return this.product.options.findIndex(
      (opt) => opt.toLowerCase() === "size"
    );
  }
}
